import './Footer.scss';
import logoSinclairSpirit from './Assets/LogoSinclairsSpirit.png';
import logoAsmtradCPC from './Assets/LogoAsmtradCpc.png';

export default function Footer()
{
    return(
        <footer>
            <a className="lienSites" href="https://asmtradcpc.zilog.fr" target="_blank" rel="noreferrer"><img src={logoAsmtradCPC} alt="Asmtrad CPC" /></a>
            <a className="lienSites" href="https://sinclair.zilog.fr" target="_blank" rel="noreferrer"><img src={logoSinclairSpirit} alt="Sinclair Spirit" /></a>
        </footer>
    )
}